module.exports = __webpack_public_path__ + "static/media/access_218.e84e07d7.ico";